var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookDesktopLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 13,
  viewBox: "0 0 13 13",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12.979 5.184c0-.706-.735-1.243-1.261-1.243h-4.19s.556-1.32.571-1.938c.016-.618-.19-1.01-.193-1.032C7.805.314 7.363 0 6.706 0c-.66 0-.444.321-.444 1.307 0 1.104-1.323 1.567-1.95 2.885C4.03 4.79 3.02 5.954 3 5.954v5.437l.554.5s6.84.062 7.184 0c.365.065.701-.324.749-1.025 0-.701-.372-.66-.372-.66s.973-.17.973-.688c0-.519-.416-1.367-.416-1.367s.919-.28.919-1.04c0-.45-.282-.934-.688-.933.264.001 1.076-.364 1.076-.994M0 12.92h2v-7H0z"
})));
export default SvgFacebookDesktopLike;